import { Box, Tooltip } from '@mui/material';
import FtaLogo from '../assets/logo.svg';

interface CertifiedBadgeProps {
  size?: number;
  showTooltip?: boolean;
}

const CertifiedBadge = ({ size = 20, showTooltip = true }: CertifiedBadgeProps) => {

  const badge = (
    <Box
      component="img"
      src={FtaLogo}
      alt="FatAllan Certified"
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
      }}
    />
  );

  if (showTooltip) {
    return (
      <Tooltip title="FatAllan Certified" arrow>
        {badge}
      </Tooltip>
    );
  }

  return badge;
};

export default CertifiedBadge;
